import { searchAccountByNameOrCode } from "./../../../services/ledger/account";
import { searchDimensionByNameOrCode } from './../../../services/ledger/dimension';
import { getAccountStatement } from './../../../services/ledger/reports';

import moment from "moment";

export default {
    namespaced: true,
    state: {
        accounts: [],
        dimensions: [
            { id: 0, name: "Without Dimension" }
        ],
        filter: {
            reference: null,
            description: null,
            min_amount: null,
            max_amount: null,
            dimension_id: null
        },
        form: {
            account_id: null,
            from: moment().startOf("month").format("YYYY-MM-DD"),
            to: moment().format("YYYY-MM-DD"),
        },
        data: {
            running: []
        }
    },
    getters: {
        filteredData(state) {
            let reference = state.filter.reference || "";
            let description = state.filter.description || "";
            let minAmount = state.filter.min_amount;
            let maxAmount = state.filter.max_amount;
            let dimension_id = state.filter.dimension_id;
            if(!state.data) return [];
            if(!state.data.running) return [];
            if(state.data.running.length == 0) [];
            return state.data.running.filter(each => {
                return each.narration.toLowerCase().indexOf(description.toLowerCase()) > -1 &&
                    each.reference_code.toLowerCase().indexOf(reference.toLowerCase()) > -1 &&
                    (minAmount ? Math.abs(each.amount) >= minAmount : true) &&
                    (maxAmount ? Math.abs(each.amount) <= maxAmount : true) &&
                    (dimension_id ? each.dimension_id == dimension_id : true) &&
                    (dimension_id == 0 ? each.dimension_id == null : true)
            });
        }
    },
    mutations: {
        accounts(state, payload) {
            state.accounts = Array.from(new Set([...state.accounts, ...payload]))
        },
        dimensions(state, payload) {
            state.dimensions = Array.from(new Set([...state.dimensions, ...payload]))
        },
        filter(state, payload) {
            state.filter[payload.key] = payload.value
        },
        form(state, payload) {
            state.form[payload.key] = payload.value
        },
        data(state, payload) {
            state.data = payload;
        }
    }, 
    actions: {
        searchAccountsAsync(context, query) {
            searchAccountByNameOrCode({search: query, limit: 10}).then(response => {
                context.commit("accounts", response.data)
            })
        },
        searchDimensions(context, query) {
            searchDimensionByNameOrCode({search: query, limit: 10}).then(response => {
                context.commit("dimensions", response.data)
            })
        },
        updateFilter(context, payload) {
            context.commit("filter", payload)
        },
        updateForm(context, payload) {
            context.commit("form", payload)
        },
        fetch(context) {
            return new Promise((resolve, reject) => {
                context.commit("data", { running: [] });
                getAccountStatement(context.state.form).then(response => {
                    context.commit("data", response.data);
                    resolve(resolve)
                }).catch(error => reject(error))
            });
        }
    }
}